import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_2 = { class: "modal-content border-0 shadow-lg rounded-4" }
const _hoisted_3 = { class: "modal-header border-bottom-dashed" }
const _hoisted_4 = { class: "modal-chip" }
const _hoisted_5 = { class: "modal-title fw-semibold mt-3 mb-1" }
const _hoisted_6 = { class: "text-muted mb-0 modal-copy" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = { class: "modal-body p-4 p-xl-40" }
const _hoisted_9 = { class: "promotion-tip-card mb-4" }
const _hoisted_10 = { class: "mb-1" }
const _hoisted_11 = { class: "mb-0 text-muted" }
const _hoisted_12 = { class: "row g-3" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "field-header" }
const _hoisted_15 = { class: "form-label fw-semibold mb-0" }
const _hoisted_16 = { class: "field-caption" }
const _hoisted_17 = { class: "reference-input-wrap" }
const _hoisted_18 = ["value", "placeholder"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "field-header" }
const _hoisted_23 = { class: "form-label fw-semibold mb-0" }
const _hoisted_24 = { class: "field-caption" }
const _hoisted_25 = ["value", "placeholder"]
const _hoisted_26 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "field-header" }
const _hoisted_29 = { class: "form-label fw-semibold mb-0" }
const _hoisted_30 = { class: "field-caption" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { value: "" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "col-md-3" }
const _hoisted_35 = { class: "field-header" }
const _hoisted_36 = { class: "form-label fw-semibold mb-0" }
const _hoisted_37 = { class: "field-caption" }
const _hoisted_38 = ["value"]
const _hoisted_39 = { value: "fixed" }
const _hoisted_40 = { value: "percentage" }
const _hoisted_41 = { class: "col-md-3" }
const _hoisted_42 = { class: "field-header" }
const _hoisted_43 = { class: "form-label fw-semibold mb-0" }
const _hoisted_44 = { class: "field-caption" }
const _hoisted_45 = ["value", "placeholder"]
const _hoisted_46 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "field-header" }
const _hoisted_49 = { class: "form-label fw-semibold mb-0" }
const _hoisted_50 = { class: "field-caption" }
const _hoisted_51 = ["value"]
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = { class: "field-header" }
const _hoisted_54 = { class: "form-label fw-semibold mb-0" }
const _hoisted_55 = { class: "field-caption" }
const _hoisted_56 = ["value"]
const _hoisted_57 = { class: "col-md-6" }
const _hoisted_58 = { class: "field-header" }
const _hoisted_59 = { class: "form-label fw-semibold mb-0" }
const _hoisted_60 = { class: "field-caption" }
const _hoisted_61 = ["value"]
const _hoisted_62 = { value: 1 }
const _hoisted_63 = { value: 0 }
const _hoisted_64 = { class: "col-md-6" }
const _hoisted_65 = { class: "field-header" }
const _hoisted_66 = { class: "form-label fw-semibold mb-0" }
const _hoisted_67 = { class: "field-caption" }
const _hoisted_68 = { class: "day-grid" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_71 = { class: "col-12" }
const _hoisted_72 = { class: "field-header" }
const _hoisted_73 = { class: "form-label fw-semibold mb-0" }
const _hoisted_74 = { class: "field-caption" }
const _hoisted_75 = ["value", "placeholder"]
const _hoisted_76 = { class: "d-flex justify-content-between align-items-center mt-4 pt-2" }
const _hoisted_77 = ["disabled"]
const _hoisted_78 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.open)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modal fade show d-block promotion-modal",
        tabindex: "-1",
        "aria-modal": "true",
        role: "dialog",
        onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.isEdit ? _ctx.$t("promotion_page.edit_chip") : _ctx.$t("promotion_page.new_chip")), 1),
                _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.isEdit ? _ctx.$t("promotion_page.update_title") : _ctx.$t("promotion_page.create_title")), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("promotion_page.modal_description")), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close shadow-none",
                "aria-label": _ctx.$t('common.close'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "tip-icon" }, [
                  _createElementVNode("i", { class: "ri-megaphone-line" })
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("h6", _hoisted_10, _toDisplayString(_ctx.isEdit ? _ctx.$t("promotion_page.edit_tip_title") : _ctx.$t("promotion_page.create_tip_title")), 1),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("promotion_page.tip_description")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("promotion_page.code")), 1),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("promotion_page.code_caption")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("input", {
                      value: _ctx.form.code,
                      type: "text",
                      class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.errors.code }]),
                      placeholder: _ctx.$t('promotion_page.code_placeholder'),
                      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update-field', 'code', ($event.target as HTMLInputElement).value)))
                    }, null, 42, _hoisted_18),
                    (!_ctx.isEdit && _ctx.canCreate)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-light generate-code-btn",
                          disabled: _ctx.loading,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('generate-code')))
                        }, [
                          _cache[15] || (_cache[15] = _createElementVNode("i", { class: "ri-refresh-line me-1" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("promotion_page.generate_code")), 1)
                        ], 8, _hoisted_19))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.errors.code)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.errors.code[0]), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("promotion_page.name")), 1),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("promotion_page.name_caption")), 1)
                  ]),
                  _createElementVNode("input", {
                    value: _ctx.form.name,
                    type: "text",
                    class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.errors.name }]),
                    placeholder: _ctx.$t('promotion_page.name_placeholder'),
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update-field', 'name', ($event.target as HTMLInputElement).value)))
                  }, null, 42, _hoisted_25),
                  (_ctx.errors.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.errors.name[0]), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("promotion_page.customer")), 1),
                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("promotion_page.customer_caption")), 1)
                  ]),
                  _createElementVNode("select", {
                    value: _ctx.form.customer_id ?? '',
                    class: "form-select modal-input",
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update-field', 'customer_id', Number(($event.target as HTMLSelectElement).value) || null)))
                  }, [
                    _createElementVNode("option", _hoisted_32, _toDisplayString(_ctx.$t("promotion_page.all_customers")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customers, (customer) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: customer.id,
                        value: customer.id
                      }, _toDisplayString(customer.name), 9, _hoisted_33))
                    }), 128))
                  ], 40, _hoisted_31)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("promotion_page.discount_type")), 1),
                    _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t("promotion_page.discount_type_caption")), 1)
                  ]),
                  _createElementVNode("select", {
                    value: _ctx.form.discount_type,
                    class: "form-select modal-input",
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update-field', 'discount_type', ($event.target as HTMLSelectElement).value)))
                  }, [
                    _createElementVNode("option", _hoisted_39, _toDisplayString(_ctx.$t("promotion_page.type_fixed")), 1),
                    _createElementVNode("option", _hoisted_40, _toDisplayString(_ctx.$t("promotion_page.type_percentage")), 1)
                  ], 40, _hoisted_38)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t("promotion_page.discount_value")), 1),
                    _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t("promotion_page.discount_value_caption")), 1)
                  ]),
                  _createElementVNode("input", {
                    value: _ctx.form.value,
                    type: "number",
                    min: "0",
                    class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.errors.value }]),
                    placeholder: _ctx.$t('promotion_page.discount_value_placeholder'),
                    onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update-field', 'value', Number(($event.target as HTMLInputElement).value || 0))))
                  }, null, 42, _hoisted_45),
                  (_ctx.errors.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.errors.value[0]), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t("promotion_page.start_date")), 1),
                    _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t("promotion_page.start_date_caption")), 1)
                  ]),
                  _createElementVNode("input", {
                    value: _ctx.form.valid_from,
                    type: "date",
                    class: "form-control modal-input",
                    onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('update-field', 'valid_from', ($event.target as HTMLInputElement).value)))
                  }, null, 40, _hoisted_51)
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.$t("promotion_page.end_date")), 1),
                    _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t("promotion_page.end_date_caption")), 1)
                  ]),
                  _createElementVNode("input", {
                    value: _ctx.form.valid_till,
                    type: "date",
                    class: "form-control modal-input",
                    onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update-field', 'valid_till', ($event.target as HTMLInputElement).value)))
                  }, null, 40, _hoisted_56)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.$t("promotion_page.status")), 1),
                    _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$t("promotion_page.status_caption")), 1)
                  ]),
                  _createElementVNode("select", {
                    value: Number(_ctx.form.status ?? 1),
                    class: "form-select modal-input",
                    onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('update-field', 'status', Number(($event.target as HTMLSelectElement).value))))
                  }, [
                    _createElementVNode("option", _hoisted_62, _toDisplayString(_ctx.$t("promotion_page.status_active")), 1),
                    _createElementVNode("option", _hoisted_63, _toDisplayString(_ctx.$t("promotion_page.status_inactive")), 1)
                  ], 40, _hoisted_61)
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.$t("promotion_page.valid_days")), 1),
                    _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.$t("promotion_page.valid_days_caption")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdayOptions, (day) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: day.value,
                        type: "button",
                        class: _normalizeClass(["day-pill", { active: _ctx.form.valid_days.includes(day.value) }]),
                        onClick: ($event: any) => (_ctx.$emit('toggle-day', day.value))
                      }, _toDisplayString(day.label), 11, _hoisted_69))
                    }), 128))
                  ]),
                  (_ctx.errors.valid_day)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString(_ctx.errors.valid_day[0]), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.$t("promotion_page.description")), 1),
                    _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.$t("promotion_page.description_caption")), 1)
                  ]),
                  _createElementVNode("textarea", {
                    value: _ctx.form.description,
                    rows: "4",
                    class: "form-control modal-input modal-textarea",
                    placeholder: _ctx.$t('promotion_page.description_placeholder'),
                    onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('update-field', 'description', ($event.target as HTMLTextAreaElement).value)))
                  }, null, 40, _hoisted_75)
                ])
              ]),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light px-4",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('close')))
                }, _toDisplayString(_ctx.$t("common.cancel")), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn style-one px-4 h-55",
                  disabled: _ctx.loading || !_ctx.canSave,
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('save')))
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_78))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.loading ? _ctx.$t("promotion_page.saving") : _ctx.isEdit ? _ctx.$t("promotion_page.update_action") : _ctx.$t("promotion_page.create_action")), 1)
                ], 8, _hoisted_77)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}